import { Box, Button, Dialog, TextField } from '@mui/material';
import React, {useState, useContext, useEffect, Fragment} from 'react';
import UpdateUserAPI from '../../api/user/update_user';
import { AuthorizationContext } from '../../context/authorizationContext';
import "./update_user_dialog.css";
import Loader from '../loader/loader';

const UpdateUserDialog = (props)=>{

    const { userDetail, setUserDetail } = useContext(AuthorizationContext);
    const [updateUserDetail, setUpdateUserDetail ] = useState({
        first_name: null,
        last_name: null,
        phone: null
    })
    const [open, setOpen] = useState(true);
    const [flagLoader, setFlagLoader] = useState(false);

    useEffect(()=>{
        setUpdateUserDetail({
            first_name: userDetail.first_name,
            last_name: userDetail.last_name,
            phone: userDetail.phone
        });
    }, [])

    const UpdateValidation = ()=>{
        if(updateUserDetail.first_name === "" || updateUserDetail.last_name === "" || updateUserDetail.phone ===""){
            return false;
        }
        else{
            return true;
        }
    }

    const UserDetailUpdate = ()=>{
        setFlagLoader(true);
        UpdateUserAPI(updateUserDetail, (res)=>{
            setFlagLoader(false);
            console.log("Printing update user rsponse", res);
            if(res.data.status === true){
                setUserDetail(res.data.data);
                setOpen(false);
                props.closeDialog(true);
            }
        }, (err)=>{
            setFlagLoader(false);
            console.log("Printing error for update user", err);
            alert("Something went wrong, Plese try again later.");
            setOpen(false);
            props.closeDialog(false);
        })
    }

    return (
        <Fragment>
            {flagLoader === true && <Loader />}
            <Dialog className="update_user_dialog" open={open}>
                <h1>Update User Details</h1>
                <Box style={{display: "flex", justifyContent: "space-between", flexWrap: "wrap"}}>
                    <Box className="update_first_name update_input_button">
                        <TextField variant='standard' label="First Name" value={updateUserDetail.first_name} onChange={(e)=>{setUpdateUserDetail({
                            ...updateUserDetail,
                            first_name: e.target.value
                        })}} placeholder="Updated First Name" />
                    </Box>
                    <Box className="update_last_name update_input_button">
                        <TextField variant='standard' label="Last Name" value={updateUserDetail.last_name} onChange={(e)=>{setUpdateUserDetail({
                            ...updateUserDetail,
                            last_name: e.target.value
                        })}} placeholder="Updated Last Name" />    
                    </Box>
                </Box>
                <Box style={{display: "flex", justifyContent: "space-between", flexWrap: "wrap"}}>
                    <Box className="update_phone update_input_button">
                        <TextField variant='standard' label="Phone" value={updateUserDetail.phone} onChange={e=>{setUpdateUserDetail({
                            ...updateUserDetail,
                            phone: e.target.value
                        })}} placeholder="Updated Phone" />    
                    </Box>
                </Box>
                <Box className="update_actions update_input_button">
                    <Button onClick={()=>{setOpen(false);props.closeDialog(false)}} className="update_action_cancel">Cancel</Button>
                    <Button disabled={!UpdateValidation()} style={UpdateValidation() === false ? {background: "grey"}: {}} onClick={UserDetailUpdate} className="update_action_submit">Update</Button>
                </Box>
            </Dialog>
        </Fragment>
    )
}

export default UpdateUserDialog;